import {useQuery} from '@tanstack/react-query';
import {fetchBalance} from '../services/BalanceService';

export const useBalance = () => {

    const balanceQuery = useQuery({
        queryKey: ['balance'],
        queryFn: () => fetchBalance(),
    });

    return {
        balance: balanceQuery.data,
        loading: balanceQuery.isLoading,
    };
};
